export default {
	reviewDocuments: {
		account: '@:component.accounts.name',
		balance: 'Balance',
		status_options: 'Status options',
		record_count_determined: 'Number of records is being determined',
		document_review_protocol: 'Document review protocol',
		automatic_reminder: 'Automatic reminder',
		edit_documents: 'Edit documents',
		edit_reviewer: 'Edit reviewer',
		deactivate: 'Deactivate',
		activate: 'Activate',
		create_protocol: 'Create protocol',
		review_requires_reviewer:
			'You must define reviewers before document review can be activated.',
		confirm_disable_review: 'Are you sure you want to disable document review?',
		confirm_finish_review_without_checks:
			'You have not reviewed any transactions. Are you sure you want to finish the document review?',
		confirm_approve_with_disputes:
			'You are approving this document review, but you have disputed at least one transaction. Are you sure?',
		confirm_reject_without_disputes:
			'You are rejecting this document review, but you have not disputed any transaction. Are you sure?',
		confirm_review_action:
			'Are you sure you want to {action} the document review?',
		reopen_notify_reviewers_info:
			'When you reopen the document review, reviewers with pending status can be notified by email.',
		notify_pending_reviewers: 'Notify pending reviewers by email',
		confirm_no_changes_after_completion:
			'After completing the document review, no further changes are possible. Do you want to continue?',
		data_updated: 'Data has been updated',
		confirm_enable_review_message:
			'Do you really want to enable the document review? A notification will be sent to the defined reviewers. Subsequent changes are not possible during the review.',
		review_completed: 'Invoice review completed',
		invoice_review_completed:
			'The invoice review is complete. You can view the report here. No further changes are possible.',
		invoice_review_completed_2:
			'The invoice review has already been completed. No further changes are possible.',
		protocol_document_type_missing:
			'No document type has been defined for the {boldStart}report{boldEnd}. Please click {linkStart}here{linkEnd} to make the necessary change.',
		invoice_protocol: 'Invoice Review Protocol',
		performedOn: 'The invoice review was performed on',
		filter: {
			incomplete: 'incomplete',
			all: 'all',
		},
		protocol: {
			reviews: 'Review',
			show_all: 'Choose another review ({count})',
			show_less: 'Close selection',
			search_label: 'Search the protocol',
			search_hint:
				'From 2 characters: text, account, date, amount, PN, comments',
			hits: 'No results | {count} result | {count} results',
			hits_capped: '{count} results · first {max}',
			denied: 'objected',
			toc: 'Contents',
			accounts: 'Accounts · {selected}/{total}',
			all: 'All',
			only_denied: 'Objected only',
			reviewers: 'Reviewers',
			states: 'Appendix · booking status',
			state_denied: 'Objected',
			state_pending: 'Not reviewed',
			state_approved: 'Confirmed',
			options: 'Options',
			show_comments: 'Show comments',
			show_appendix: 'Appendix: all bookings',
			panel: 'Scope, contents and search',
			load_incomplete:
				'Not all data could be loaded. The protocol cannot be created like this.',
			reload: 'Load again',
			size_warning:
				'The protocol is very large ({size}) and may exceed the permitted size for PDF creation. Do you want to hide the appendix?',
			size_hide_appendix: 'Create without appendix',
			size_keep: 'Create with appendix',
		},
		cockpit: {
			phase: {
				draft: 'Draft · not active',
				active: 'Active · review in progress',
				completed: 'Completed',
				completed_on: 'Completed on {date}',
			},
			meta: {
				accounting_year: 'Accounting year {year}',
				deadline: 'Due {date}',
				no_deadline: 'no deadline',
			},
			links: {
				building: 'Go to property',
				overview: 'Back to the review overview',
				person: 'Go to person',
			},
			info: {
				open: 'Details',
				building: 'Property',
				accounting_year: 'Accounting year',
				deadline: 'Due date',
			},
			manage: {
				menu: 'Manage',
				open_settings: 'Settings',
				open_settings_hint: 'Settings and reviewers',
				comments_on: 'Enable comments',
				comments_off: 'Disable comments',
				edit: 'Edit document review',
				edit_hint: 'Completed — read only',
				reviewers_hint: 'Editable in draft only',
				documents_hint: 'Completed — read only',
			},
			hint: {
				management:
					'Management view: reviewers, activation, completion, protocol. The review itself is done by the people with write access.',
				write:
					'Write access · keys: G reviewed, B dispute, Z undo, N next open, ←/→ browse, / search.',
				write_touch: 'Write access: review and comment.',
				own_progress: '{done} of {total} processed.',
				read: 'Read access: view and comment, but not review.',
				none: 'You are not assigned as a reviewer for this document review.',
			},
			lock: {
				management:
					'Management does not review itself — that is done by the people with write access.',
				draft:
					'Not activated yet — reviewing is only possible in the active phase.',
				completed: 'Completed — everything is read-only.',
				read: 'Read access: you can view, but not review.',
				submitted:
					'Your overall result has been submitted — reviewing transactions is locked.',
				login_as:
					'You are logged in as another person — reviewing is not possible in this session.',
				login_as_short: 'Not possible while logged in as another person',
			},
			protocol_lock: {
				status:
					'The protocol has been created — the receipt review is now final. It can no longer be reopened; deadline and results stay unchanged.',
				deadline:
					'The protocol makes the receipt review final — the deadline can no longer be changed.',
				withdraw:
					'The protocol has been created — results can no longer be withdrawn.',
				confirm_create:
					'Creating the protocol makes the receipt review final: afterwards it can no longer be reopened, the deadline can no longer be changed and no result can be withdrawn. Do you want to create the protocol now?',
			},
			withdraw: {
				journal: 'Undo review',
				own_approved: 'Reviewed by you',
				own_denied: 'Disputed by you',
				overall: 'Withdraw overall result',
				overall_hint:
					'Your overall result becomes open again — you can continue reviewing afterwards.',
				deadline_passed:
					'The review deadline has passed — please contact the management.',
				blocked: 'The overall result cannot be withdrawn at the moment.',
				confirm_overall:
					'Do you really want to withdraw your overall result? It becomes open again, and a completed document review is reopened by this.',
				reviewer: 'Withdraw overall result of {name}',
				confirm_reviewer:
					'Do you really want to withdraw the overall result of {name}? They can review again afterwards.',
			},
			progress: {
				title: 'Review progress',
				title_own: 'Your review progress',
				consensus_line:
					'Consensus: {approved} reviewed · {denied} disputed · {open} open',
				summary: '{done} of {total} transactions',
				approved: 'reviewed',
				denied: 'disputed',
				open: 'open',
				hint: 'Consensus across all reviewers: reviewed = everyone agreed · disputed = at least one objection · open = everything else',
			},
			scale: {
				personal: 'Counts your own votes',
				consensus: 'Counts the consensus across all reviewers',
			},
			reviewers: {
				title: 'Reviewers',
				summary: '{done} of {total} completed',
				subline: '{count} reviewers · {readers} read-only',
				subtitle: 'Progress and overall result',
				subtitle_result: 'Overall result',
				open_list: 'Open reviewer list',
				progress_unknown: 'no progress available',
				no_result: 'no result',
				empty: 'No reviewers have been assigned to this document review yet.',
			},
			finder: {
				title: 'Search',
				open: 'Search accounts and transactions',
				placeholder:
					'Search accounts and transactions — number, name, text, amount, date, comments, receipts …',
				hint: 'Receipt titles and file names are searched as well. Multiple words are combined with AND. Dates in German format: 02.05.2026, 05.2026 for the month, 02.05. for that day in any year.',
				accounts: 'Accounts',
				journals: 'Transactions',
				documents: 'Review attachments',
				empty: 'Nothing found.',
				start:
					'Start typing to search every account and transaction of this review.',
				more: '{count} more matches — refine your search',
			},
			accounts: {
				title: 'Accounts',
				search: 'Search account (no./name) …',
				empty: 'No accounts for this search and filter.',
				footer:
					'{shown} of {total} accounts · {journals} transactions in total',
				progress_own: '{done} of {total} transactions processed by you',
				progress_consensus:
					'{done} of {total} transactions finally assessed (all reviewers)',
				denied_hint:
					'{count} transactions disputed — consensus across all reviewers, independent of your own vote',
				filter: {
					all: 'All {count}',
					open: 'Open {count}',
					denied: 'Disputed {count}',
				},
			},
			journals: {
				title: 'Transactions',
				search: 'Search transaction …',
				empty: 'No transactions for this search and filter.',
				no_account: 'Please select an account.',
				footer: '{shown} of {total} shown · {accountTotal} in this account',
				load_more: 'Load {count} more',
				load_more_rest: 'Load {count} more · {remaining} remaining',
				primanota: 'PN {value}',
				amount: {
					debit_short: 'D',
					credit_short: 'C',
					hint: '{kind}: {amount}',
				},
				sort: {
					label: 'Sorting',
					menu: 'Sort transactions',
					asc: 'ascending',
					desc: 'descending',
					by: {
						booking_date: 'Booking date',
						debit: 'Debit',
						credit: 'Credit',
						booking_text: 'Booking text',
					},
				},
				filter: {
					all: 'All {count}',
					open: 'Open {count}',
					denied: 'Disputed {count}',
					approved: 'OK {count}',
				},
				state: {
					approved: 'Reviewed (all reviewers)',
					denied: 'Disputed',
					pending: 'Pending',
				},
				bulk: {
					approve: 'Mark all transactions of this account as reviewed',
					deny: 'Dispute all transactions of this account',
					selected_approve: 'Mark {count} selected transactions as reviewed',
					selected_deny: 'Dispute {count} selected transactions',
					confirm_approve:
						'Do you really want to mark all {count} transactions of this account as reviewed?',
					confirm_deny:
						'Do you really want to dispute all {count} transactions of this account?',
				},
			},
			selection: {
				enter: 'Select several transactions',
				exit: 'Leave selection mode',
				count: '{count} selected',
				approve: 'Mark selection as reviewed',
				deny: 'Dispute selection',
				clear: 'Clear selection',
				confirm_approve:
					'Do you want to mark the {count} selected transactions as reviewed?',
				confirm_deny:
					'Do you want to dispute the {count} selected transactions?',
				toast: {
					failed:
						'{failed} of {total} transactions could not be saved: {message}. They stay selected.',
				},
			},
			actions: {
				approve: 'Reviewed',
				deny: 'Dispute',
				overall_approve: 'Confirm',
				overall_deny: 'Dispute',
				overall_approve_hint:
					'Completes your review: you confirm the entire receipt review.',
				overall_deny_hint:
					'Completes your review: you dispute the entire receipt review and withhold approval.',
				next_open: 'Next open',
				previous_journal: 'Previous transaction',
				next_journal: 'Next transaction',
				back: 'Back',
				documents: 'Documents',
				protocol: 'Protocol',
			},
			toast: {
				no_open_left:
					'No open transactions left for you — submit your overall result above.',
				review_blocked:
					'Reviewing is not possible — your role, the phase or your submitted overall result block this action.',
				reviewers_locked: 'Reviewers can only be changed before activation.',
				protocol_locked: 'The protocol is only available after completion.',
				review_failed: 'The review could not be saved: {message}',
			},
			keyboard: {
				legend:
					'Keyboard: G reviewed · B dispute · Z undo · N next open · ←/→ browse',
				legend_navigation: 'Keyboard: N next open · ←/→ browse',
				key_approve: 'Key G',
				key_deny: 'Key B',
				key_withdraw: 'Key Z',
			},
			tour: {
				open: 'Start the introduction to the document review',
				menu_item: 'Introduction',
				shared: {
					finder: {
						title: 'Search',
						text: 'Press <kbd>/</kbd> or the magnifier to search all accounts and bookings – by number, name, booking text, amount, date, comment or receipt. A hit jumps straight to the account or booking.',
					},
					finder_touch: {
						title: 'Search',
						text: 'Open the search via ☰. It covers all accounts and bookings by number, name, booking text, amount, date, comment or receipt. Tapping a hit takes you straight to the account or booking.',
					},
					focus: {
						title: 'Focus mode',
						text: 'Press <kbd>F</kbd> to hide everything else and review booking by booking with a large receipt. ←/→ browses, across accounts too; the bar at the bottom lists the shortcuts. Leave via the ✕ top right or <kbd>Esc</kbd>.',
					},
				},
				reviewer: {
					welcome: {
						title: 'Welcome to the document review',
						text: 'In a few steps we show you how to review accounts and bookings. The introduction only shows and explains – it never approves, disputes or changes anything. Close it at any time with the ✕.',
					},
					phase: {
						title: 'Review state',
						text: '<strong>Draft</strong>: the management is preparing the review. <strong>Active</strong>: the review is running, you can review bookings. <strong>Completed</strong>: the result is final. Once the protocol is created nothing can be changed.',
					},
					progress: {
						title: 'Progress',
						text: 'The bar shows how many bookings are reviewed, disputed and still open. Click it to see each reviewer’s state.',
					},
					info: {
						title: 'Review details',
						text: 'Here you find the property, accounting year and deadline of this review.',
					},
					accounts: {
						title: 'Accounts',
						text: 'On the left are all accounts of the review with their progress. Search by number or name; the filters show all, open only or disputed only.',
					},
					accounts_touch: {
						title: 'Accounts',
						text: 'These are all accounts of the review with their progress. Search by number or name; the filters show all, open only or disputed only.',
					},
					levels: {
						title: 'Accounts → bookings → receipt',
						text: 'On this screen you always see one level. Tap an account to open its bookings, then tap a booking to see its receipt. The <strong>‹</strong> arrow at the top left takes you one level back.',
					},
					journals: {
						title: 'Bookings',
						text: 'These are the bookings of the selected account. Each one is <strong>open</strong>, <strong>reviewed</strong> or <strong>disputed</strong>. Search, sort and filter at the top of the column. The introduction selected the next open booking for you.',
					},
					journals_touch: {
						title: 'Bookings',
						text: 'These are the bookings of the selected account. Each one is <strong>open</strong>, <strong>reviewed</strong> or <strong>disputed</strong>; search, sort and filter at the top of the list. The introduction selected the next open booking for you. Tap a booking to open its receipt. The <strong>‹</strong> arrow takes you back to the accounts.',
					},
					bulk: {
						title: 'Several bookings at once',
						text: 'Multi-select marks several bookings so you can review or dispute them together.',
					},
					receipt: {
						title: 'The receipt',
						text: 'This is the receipt of the booking – from the ERP or attached by the management. Zoom, rotate, browse, download and print. If a receipt has several sheets, switch them with the bar above.',
					},
					receipt_touch: {
						title: 'The receipt',
						text: 'This is the receipt of the booking, from the ERP or attached by the management. Zoom, rotate, browse, download and print. <strong>‹</strong> and <strong>›</strong> above it switch to the previous or next booking; the arrow at the very top left takes you back to the booking list.',
					},
					layout: {
						title: 'Receipt above or beside',
						text: 'Switch between the receipt inside the detail area and its own column next to it – handy on large screens. Your browser remembers the choice.',
					},
					verdict: {
						title: 'Reviewing',
						text: '<strong>Reviewed</strong> (<kbd>G</kbd>) confirms the booking and jumps to the next open one. <strong>Dispute</strong> (<kbd>B</kbd>) marks it as faulty – please give a reason in a comment. <strong>Undo</strong> (<kbd>Z</kbd>) withdraws your verdict. <strong>Next open</strong> (<kbd>N</kbd>) moves on without a verdict.',
					},
					verdict_readonly: {
						title: 'Reviewers’ verdicts',
						text: 'You have read access here or the review is not running: you see the state but cannot review yourself. <kbd>N</kbd> and ←/→ still browse the bookings.',
					},
					verdict_touch: {
						title: 'Reviewing',
						text: 'The review bar always sits at the bottom of the screen. <strong>Reviewed</strong> confirms the booking and jumps to the next open one. <strong>Dispute</strong> marks it as faulty; please give a reason in a comment. <strong>Undo</strong> withdraws your verdict, <strong>Next open</strong> moves on without a verdict.',
					},
					verdict_readonly_touch: {
						title: 'Reviewers’ verdicts',
						text: 'You have read access here or the review is not running: you see the state but cannot review yourself. The buttons of this bar still browse the bookings.',
					},
					journal_comments: {
						title: 'Booking comments',
						text: 'Write questions and reasons directly on the booking. The other reviewers and the management see them.',
					},
					review_comments: {
						title: 'Review comments',
						text: 'Remarks that do not concern a single booking go here. The number shows how many there are.',
					},
					documents: {
						title: 'Attachments',
						text: 'The paperclip opens the review’s documents, e.g. annual statement, bank statements or contracts.',
					},
					overall: {
						title: 'Your overall result',
						text: 'When you are done, submit your overall result here: <strong>Confirm</strong> or <strong>Dispute</strong>. This completes your own review. While the deadline runs and no protocol exists you can withdraw it.',
					},
					keys: {
						title: 'Keyboard shortcuts',
						text:
							'<table class="aaremo-tour-keys"><tbody>' +
							'<tr><td><kbd>G</kbd></td><td>Reviewed</td><td><kbd>/</kbd></td><td>Search</td></tr>' +
							'<tr><td><kbd>B</kbd></td><td>Dispute</td><td><kbd>F</kbd></td><td>Focus mode</td></tr>' +
							'<tr><td><kbd>Z</kbd></td><td>Undo</td><td><kbd>←</kbd> <kbd>→</kbd></td><td>Browse</td></tr>' +
							'<tr><td><kbd>N</kbd></td><td>Next open</td><td><kbd>Esc</kbd></td><td>Close</td></tr>' +
							'</tbody></table>' +
							'In the receipt: <kbd>+</kbd> <kbd>−</kbd> zoom, <kbd>0</kbd> fit, <kbd>R</kbd> rotate, <kbd>PgUp</kbd> <kbd>PgDn</kbd> browse.',
					},
					menu: {
						title: 'The ☰ menu',
						text: 'Behind ☰ you find the <strong>search</strong>, the review’s <strong>attachments</strong> (e.g. annual statement, bank statements, contracts), the <strong>review comments</strong>, your <strong>overall result</strong> and this <strong>introduction</strong>. The number on the menu counts attachments and comments. When you are done, submit your overall result there: <strong>Confirm</strong> or <strong>Dispute</strong>. While the deadline runs and no protocol exists you can withdraw it.',
					},
					menu_readonly: {
						title: 'The ☰ menu',
						text: 'Behind ☰ you find the <strong>search</strong>, the review’s <strong>attachments</strong> (e.g. annual statement, bank statements, contracts), the <strong>review comments</strong> and this <strong>introduction</strong>. The number on the menu counts attachments and comments.',
					},
					outro: {
						title: 'Happy reviewing',
						text: 'You can restart this introduction any time via the <strong>?</strong> at the top of the review.',
					},
					outro_touch: {
						title: 'Happy reviewing',
						text: 'You can restart this introduction any time via ☰ → <strong>Introduction</strong>.',
					},
				},
				manager: {
					welcome: {
						title: 'Managing a document review',
						text: 'We show you how to set up a review, choose reviewers, upload attachments and assign bookings. The introduction only shows – it never saves, activates or assigns anything.',
					},
					lifecycle: {
						title: 'The workflow',
						text: 'A review starts as a <strong>draft</strong>: you set master data and reviewers. <strong>Activate</strong> starts the review. After <strong>completing</strong> it you create the protocol – from then on the review is final: no reopening, no new deadline, no withdrawing.',
					},
					gear: {
						title: 'Settings and reviewers',
						text: 'The gear opens everything you configure for this review.',
					},
					menu: {
						title: 'The ☰ menu',
						text: 'Behind ☰ you find the <strong>search</strong>, the <strong>attachments</strong>, the <strong>review comments</strong>, the <strong>settings</strong> with master data, reviewers and status, and this <strong>introduction</strong>. The number on the menu counts attachments and comments.',
					},
					basics: {
						title: 'Master data',
						text: 'The first tab holds name, deadline and the other details of the review.',
					},
					basics_touch: {
						title: 'Master data',
						text: 'Open this dialog via ☰ → <strong>Settings</strong>. The first tab holds name, deadline and the other details of the review.',
					},
					status: {
						title: 'Status',
						text: 'Next to it is the status with Activate, Deactivate, Complete, Reopen and Protocol – each with a sentence on what it does. Comments are switched on or off here as well.',
					},
					status_touch: {
						title: 'Status',
						text: 'Below the master data is the status with Activate, Deactivate, Complete, Reopen and Protocol, each with a sentence on what it does. Comments are switched on or off here as well.',
					},
					reviewers: {
						title: 'Choosing reviewers',
						text: 'In the “Reviewers” tab you pick people via search and checkmarks and decide whether they take part <strong>read-only</strong> (view and comment) or <strong>writing</strong> (review and submit a result). Reviewers can only be changed while the review is a draft.',
					},
					save: {
						title: 'Saving',
						text: '“Save” keeps the dialog open, “Save & close” closes it afterwards. The introduction closes the dialog again without saving.',
					},
					documents_open: {
						title: 'Attachments',
						text: 'The paperclip opens the review’s attachments. Reviewers can only view them, you can maintain them.',
					},
					documents_upload: {
						title: 'Uploading documents',
						text: 'Drop files here or pick them. Each document gets a document type and a name.',
					},
					documents_upload_touch: {
						title: 'Uploading documents',
						text: 'Open the attachments via ☰ → <strong>Attachments</strong>. Tap here to pick files. On a computer you can also drop them here. Each document gets a document type and a name.',
					},
					documents_split: {
						title: 'One document or several',
						text: 'Several files normally become one document. With this switch each file becomes its own document – handy for many single receipts.',
					},
					documents_assign: {
						title: 'Assigning bookings',
						text: 'Here you see which bookings the selected document is assigned to. Use <strong>+</strong> to pick account and booking and assign it – it then shows as the receipt of that booking. A booking carries at most one receipt.',
					},
					documents_assign_touch: {
						title: 'Assigning bookings',
						text: 'Here you see which bookings the selected document is assigned to. Use <strong>+</strong> to pick account and booking and assign it. It then shows as the receipt of that booking. A booking carries at most one receipt. The arrow at the top left takes you back to the list of documents.',
					},
					receipt_assign: {
						title: 'Receipt right at the booking',
						text: 'If a booking has no receipt, assign an existing attachment here or upload a new one – the booking is preselected.',
					},
					reviewer_panel: {
						title: 'Reviewer progress',
						text: 'Here you see each reviewer’s progress and submitted overall result. As long as nothing is final you can withdraw an overall result.',
					},
					outro: {
						title: 'All set',
						text: 'Restart this introduction any time via the <strong>?</strong> at the top. Your reviewers get their own introduction when they first open the review.',
					},
					outro_touch: {
						title: 'All set',
						text: 'Restart this introduction any time via ☰ → <strong>Introduction</strong>. Your reviewers get their own introduction when they first open the review.',
					},
				},
			},
			focus: {
				open: 'Focus',
				open_hint: 'Review view without header and navigation',
				close: 'Leave focus',
				subline: 'Document review · accounting year {year}',
				receipt_position: 'Receipt {position} of {total}',
				consensus: '{approved} reviewed · {denied} disputed',
				account_position: '{account} · transaction {position} of {total}',
				reviews: 'Reviews · {done} of {total}',
				approve: 'Reviewed — next',
				deny: 'Dispute',
				deny_hint: 'Please justify a dispute in a comment.',
				comments: 'Comments · {count}',
				comments_hint: 'Comment in the receipt review',
				queue: 'Queue',
				comments_empty: 'No comments on this entry yet.',
				comments_reply: 'Reply',
				comments_reply_to: 'Replying to {name}',
				position: 'Entry {position} of {total}',
				switch_account: 'Switch account',
				no_receipt: 'No receipt is attached to this transaction.',
				field: {
					date: 'Booking date',
					primanota: 'Primanota',
					contra_account: 'Contra account',
					debit: 'Debit',
					credit: 'Credit',
				},
				keys: {
					approve: 'Reviewed',
					deny: 'Dispute',
					next: 'Next open',
					withdraw: 'Undo',
					step: 'Browse',
					exit: 'Leave',
				},
			},
			receiptAssign: {
				title: 'Assign attachment',
				available:
					'{count} document of this review | {count} documents of this review',
				upload: 'Upload new',
				search: 'Search attachment (name, file name) …',
				none: 'This review has no attachments yet. Upload a document first.',
				noMatch: 'No attachment matches your search.',
				unnamed: 'Unnamed document',
				fileCount: '{count} file | {count} files',
				unassigned: 'not assigned to a booking yet',
				replaces: 'existing assignment would be replaced',
				hint: 'Saved immediately and visible to all reviewers.',
				submit: 'Assign',
				assigned: 'The attachment has been assigned to the booking.',
			},
			receipt: {
				title: 'Transaction',
				no_journal: 'Please select a transaction.',
				download: 'Download receipt',
				none: 'There is no receipt for this transaction.',
				open: 'Open receipt window',
				close: 'Close receipt window (Esc)',
				window: 'Receipt',
				fileCount: '{count} file | {count} files',
				origin: {
					erp: 'ERP',
					attachment: 'Attachment',
					none: 'no receipt',
				},
				type: {
					pdf: 'PDF',
					image: 'Image',
					file: 'File',
					none: 'No receipt',
				},
				viewer: {
					loading: 'Loading receipt …',
					load_error: 'The receipt could not be loaded.',
					zoom_in: 'Zoom in (+ or Ctrl+wheel)',
					zoom_out: 'Zoom out (− or Ctrl+wheel)',
					rotate: 'Rotate (R)',
					fullscreen: 'Fullscreen',
					fullscreen_exit: 'Exit fullscreen (Esc)',
					download: 'Download',
					print: 'Print',
					prev_page: 'Previous page (←)',
					next_page: 'Next page (→)',
				},
			},
			journal_reviews: {
				progress: '{done} of {total} reviewed',
				disputed: '{count} disputed',
				empty:
					'No reviewers with write access have been defined for this document review yet.',
			},
			comments: {
				placeholder: 'Comment on this entry …',
				readonly:
					'The document review is completed — comments can only be read.',
				readonly_no_permission: 'Comments are read-only for you.',
				title: 'Comments',
				open_review: 'Comments on the document review',
				open_account: 'Comments on the account',
				total: '{count} comment | {count} comments',
				empty: 'No comments yet.',
				reply: 'Reply',
				reply_to: 'Replying to {name}',
				placeholder_review: 'Comment on the document review …',
				placeholder_account: 'Comment on the account …',
				disabled:
					'Comments are switched off for this document review — existing ones stay readable.',
				no_permission: 'You cannot comment on this document review.',
				internal: 'Internal',
				internal_hint: 'Only visible to the property management',
			},
			confirm: {
				step: 'Question {current} of {total}',
			},
			protocol: {
				not_generated: 'The protocol has not been generated yet.',
			},
			reviewer_dialog: {
				persons: 'Persons of the property',
				no_match: 'No person matches your search.',
				only_with_account: 'Only persons with a user account can review.',
				access_per_person: 'Access per person',
				access_hint:
					'Read = view and comment · Write = review and submit a result.',
				selected: '{count} reviewers selected',
			},
			documents: {
				hint: 'Attachments of the review — the receipts of the transactions come from the ERP and cannot be changed here.',
				locked:
					'Completed — the attachments are read-only and can only be viewed.',
				readonly:
					'Read only — the attachments of the document review are maintained by the management.',
				empty: 'No attachments have been added yet.',
				open: 'Attachments of the document review',
				manage: 'Maintain attachments',
				download_file: 'Download file',
				no_preview:
					'There is no preview for this file type — please download the file.',
				rules:
					'A booking carries at most one receipt. ERP receipts are never replaced. Deletions only take effect on "Save".',
				assign: {
					title: 'Booking',
					account: 'Account of this document review',
					journal: 'Booking',
					without_receipt: 'Without receipt only',
					choose_account: 'Please select an account first.',
					attach: 'Assign',
					attach_dated: 'Assign booking {date}',
					prepare: 'Prepare',
					prepare_dated: 'Prepare booking {date}',
					prepared: 'Prepared — the booking is assigned on "Save".',
					pending: 'will be assigned',
					remove_pending: 'Remove preparation',
					needs_file:
						'Add a file first — the booking can then be prepared and is assigned on "Save".',
					detach: 'Remove assignment',
					assigned: 'Assigned bookings',
					after_save:
						'Bookings can be assigned as soon as the document has been saved.',
					accounts_group: 'Accounts',
					journals_group_without: 'Without receipt',
					journals_group_all: 'Bookings',
					origin_attachment: 'Attachment',
					origin_erp: 'ERP',
					origin_none: 'no receipt',
					none: 'This receipt is not assigned to any booking yet.',
					overwrite:
						'Another receipt is already assigned to this booking. Assigning will replace the existing one.',
					attached: 'The booking has been assigned to the receipt.',
					detached: 'The assignment has been removed.',
				},
			},
			edit: {
				title: 'Edit document review',
				deadline_hint:
					'Changing the deadline reopens an already completed document review.',
				reminder_requires_deadline:
					'The reminder can only be chosen once a deadline is set.',
				team_locked:
					'The contact person can no longer be changed once a protocol has been generated.',
			},
		},
	},
}
